import { styled } from '@mui/material';

const PREFIX = 'RefreshGPCOption';

export const refreshGPCOptionClasses = {
  menuItemRow: `${PREFIX}-menuItemRow`,
  refreshDateLabel: `${PREFIX}-refreshDateLabel`,
  refreshIconContainer: `${PREFIX}-refreshIconContainer`,
};

export const RefreshGPCOptionRoot = styled('div')(() => ({
  [`& .${refreshGPCOptionClasses.menuItemRow}`]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },

  [`& .${refreshGPCOptionClasses.refreshDateLabel}`]: {
    fontSize: 10,
    fontWeight: 'bold',
  },

  [`& .${refreshGPCOptionClasses.refreshIconContainer}`]: {
    marginLeft: 20,
  },
}));